import constants from "../constants/constants";
import { Link } from "react-router-dom";
import { useUserParams } from "../hooks/useUserParams";

export default function Hero() {
    const { getCurrentAgentName, getCurrentHeadshot } = useUserParams();
    const agentName = getCurrentAgentName() || constants.AGENT_NAME;
    const headshot = getCurrentHeadshot() || constants.HEADSHOT;

    return (
        <div
            className="w-full min-h-[100vh] relative overflow-hidden flex items-center justify-center"
            style={{
                backgroundColor: constants.RURAL_COLORS.background,
                border: constants.RURAL_BORDERS.double,
                boxShadow: constants.RURAL_BORDERS.shadow,
            }}
        >
            <video
                className="absolute top-0 left-0 w-full h-full object-cover z-0 opacity-60"
                src={constants.HOME_VIDEO}
                autoPlay
                loop
                muted
                playsInline
            />
            <div className="p-12 rounded-xl border-4 border-[${constants.RURAL_COLORS.border}] bg-[rgba(255,255,255,0.85)] shadow-lg flex flex-col items-center z-10">
                <div className="flex flex-row items-center gap-6">
                    <div className="flex flex-col items-center gap-4">
                        <h1 className="text-[${constants.RURAL_COLORS.primary}] text-5xl sm:text-7xl font-mont tracking-wider drop-shadow-md font-bold">
                            {agentName}
                        </h1>
                        <h3 className="text-[${constants.RURAL_COLORS.secondary}] text-2xl font-serif mt-5 whitespace-normal italic">
                            {constants.SLOGAN}
                        </h3>
                        {/* Action Buttons */}
                        <div className="flex flex-row gap-4 mt-8">
                            <Link to="/about" className="btn-primary">
                                Learn More
                            </Link>
                            <Link to="/listings" className="btn-secondary">
                                See Listings
                            </Link>
                        </div>
                    </div>
                    <img
                        src={headshot}
                        alt="Headshot"
                        width={400}
                        height={400}
                        className="rounded-full"
                    />
                </div>
            </div>
        </div>
    );
}
